// frontend/src/components/EventsSection/EventsSection.js

import React from 'react';
import './EventsSection.css';

const EventsSection = () => {
    return (
        <div id="events" className="events-section">
            <div className="events-content">
                <h2>Upcoming Events</h2>
                <p>Stay tuned for the latest events and workshops hosted by NSBE UMBC. Join us in our mission to foster community engagement and professional development.</p>
            </div>
        </div>
    );
};

export default EventsSection;
